'use client';

import { useUser } from '@auth0/nextjs-auth0';
import { resetUser } from 'actions/DevTools';

import { useAppDispatch } from 'lib/hooks';
import { setLocation } from 'slices/locationSlice';
import { setUserDatabase } from 'slices/userSlice';

const DevUserReset = () => {
  const { user } = useUser();
  const dispatch = useAppDispatch();

  if (!user) {
    return null;
  }

  return (
    <section>
      <h3>Reset User</h3>
      <p>This cannont be undone, proceed with caution</p>
      <button
        className="button"
        onClick={async () => {
          const dbUser = await resetUser();
          dispatch(
            setUserDatabase({ ...dbUser, created_at: null, updated_at: null })
          );
          dispatch(
            setLocation({
              countyFips: dbUser.county_fips as string,
              countyName: dbUser.county_name as string,
              state: dbUser.state as string,
              zipcode: dbUser.zipcode as string,
            })
          );
        }}
      >
        Reset
      </button>
    </section>
  );
};

export default DevUserReset;
